export default "__VITE_ASSET__Bxo6EPAE__"